import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
// import emailModel from '../../../../examine/auditManage/components/emailModel.vue';
import emailModel from '@/views/examine/auditManage/emailModel.vue';
import quillConfig from '@/views/components/editor/quill-config.js';
import { quillEditor } from 'vue-quill-editor';
export default {
  props: {
    notifyData: {},
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      emailForm: {},
      addEmailVisible: false,
      // emailVisiable: false,
      quillOption: quillConfig,
      notifyObj: {},
      allFileTemplate: []
    };
  },
  created() {
    var _this$notifyObj$fileT;
    console.log(this.notifyData, 'this.notifyData');
    // JSON.stringify()
    let notify = this.notifyData.notify[0];
    this.notifyObj = JSON.parse(JSON.stringify(notify));
    this.notifyObj.cc = this.notifyObj.cc ? this.notifyObj.cc.split(',') : [];
    this.notifyObj.bcc = this.notifyObj.bcc ? this.notifyObj.bcc.split(',') : [];
    this.notifyObj.recipient = this.notifyObj.recipient ? this.notifyObj.recipient.split(',') : [];
    let fileTemplate = [];
    (_this$notifyObj$fileT = this.notifyObj.fileTemplate) === null || _this$notifyObj$fileT === void 0 || _this$notifyObj$fileT.forEach(item => {
      fileTemplate.push(item.url);
    });
    this.notifyObj.fileTemplate = fileTemplate;
    this.allFileTemplate = this.notifyData.notify[0].fileTemplate;
  },
  watch: {
    notifyData: {
      handler(val) {
        console.log(val, 'this.notifyData');
        // this.notifyObj = val;
      },
      deep: true
    }
  },
  components: {
    emailModel,
    quillEditor
  },
  computed: {
    dataRule() {
      return {};
    },
    emailVisiable: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    // 发送邮件
    closeEmailVisible() {
      var _this$allFileTemplate;
      if (this.notifyObj.recipient.length < 1) {
        this.$message.error(this.$t('至少设置一个收件人'));
        return;
      }
      let notify = JSON.parse(JSON.stringify(this.notifyObj));
      notify.cc = notify.cc.join(',');
      notify.bcc = notify.bcc.join(',');
      notify.recipient = notify.recipient.join(',');
      let fileList = [];
      (_this$allFileTemplate = this.allFileTemplate) === null || _this$allFileTemplate === void 0 || _this$allFileTemplate.forEach(item => {
        if (this.notifyObj.fileTemplate.indexOf(item.url) != -1) {
          fileList.push({
            name: item.name,
            url: item.url
          });
        }
      });
      notify.fileTemplate = fileList;
      let notifyData = JSON.parse(JSON.stringify(this.notifyData));
      notifyData.notify[0] = notify;
      notifyData.fileTemplate = this.allFileTemplate;
      console.log(notify, 'this.notifyObj');
      this.emailVisiable = false;
      this.$emit('closeModel', notifyData);
    },
    addEmail(key) {
      this.addEmailType = key;
      let titleMap = {
        recipient: this.$t('收件人邮箱'),
        is_cc: this.$t('抄送人邮箱'),
        is_bcc: this.$t('密送人邮箱')
      };
      this.addEmailTitle = titleMap[key];
      this.addEmailVisible = true;
    },
    deleteEmail(type, index) {
      this.notifyObj[type].splice(index, 1);
    },
    settingEmail() {},
    cancelAddEmail(emails) {
      if (emails && Array.isArray(emails) && emails.length > 0) {
        this.notifyObj[this.addEmailType] = this.notifyObj[this.addEmailType].concat(emails);
      }
      this.addEmailType = '';
      this.addEmailTitle = '';
      this.addEmailVisible = false;
    },
    onCheckChange(e, key) {
      this.notifyObj[key] = e.target.checked;
    }
  }
};